// extracted by mini-css-extract-plugin
module.exports = {"holidayCheckboxWrapper":"OverlayComponent__holidayCheckboxWrapper___FeteL","checkBoxLabel":"OverlayComponent__checkBoxLabel___3r5xf"};